export type Factory<T> = (overrides?: Partial<T>) => T;

export const addBuilder = <T>(overrides?: Partial<T>) => {
  return function () {
    return {
      // @ts-expect-error can't really type `this` here
      ...(this as T),
      ...overrides,
    };
  };
};

export const randomId = () => `${Math.round(Math.random() * 10000000000)}`;
export const randomUuid = () => crypto.randomUUID();
